module.exports.getPromoBonus = (promo) => {
  return promo.type === 'fix' ? +promo.bonus : +Math.floor(Number(promo.robux_amount_no_promo * promo.bonus)).toFixed(2)
}
